export default [
  {
    path: '/classcard/classrankall',
    name: 'PageClassrankAll',
    component: () =>
      import(
        /* webpackChunkName: "classcard" */ '../pages/classrank/PageClassrankAll'
      ),
    meta: { modular: 21, title: '班级评比', info: '班级评比——全校' }
  },
  {
    path: '/classcard/classrankEdit',
    name: 'PageClassrankEdit',
    component: () =>
      import(
        /* webpackChunkName: "classcard" */ '../pages/classrank/PageClassrankEdit'
      ),
    meta: { modular: 21, title: '班级评比编辑', info: '班级评比——编辑' }
  },
  {
    path: '/classcard/classrankExport',
    name: 'PageClassrankExport',
    component: () =>
      import(
        /* webpackChunkName: "classrank" */ '../pages/classrank/PageClassrankExport'
      ),
    meta: { modular: 21, title: '班级评比导出', info: '班级评比——导出' }
  },
  {
    path: '/classcard/classrank/approval',
    name: 'PageClassrankApproval',
    component: () =>
      import(
        /* webpackChunkName: "classrank" */ '../pages/classrank/PageClassrankApproval'
      ),
    meta: {
      keepAlive: true,
      modular: 21,
      title: '我的审批',
      info: '班级评比——我的审批'
    }
  },
  {
    path: '/classcard/classrank/approval/history',
    name: 'PageClassrankApprovalHistory',
    component: () =>
      import(
        /* webpackChunkName: "classrank" */ '../pages/classrank/PageClassrankApprovalHistory'
      ),
    meta: {
      keepAlive: true,
      modular: 21,
      title: '历史审批',
      info: '班级评比——历史审批'
    }
  },
  {
    path: '/classcard/classrank/approval/filter',
    name: 'PageClassrankApprovalFilter',
    component: () =>
      import(
        /* webpackChunkName: "classrank" */ '../pages/classrank/PageClassrankApprovalFilter'
      ),
    meta: {
      keepAlive: true,
      modular: 21,
      title: '筛选',
      info: '班级评比审批——筛选'
    }
  },
  {
    path: '/classcard/classrank/setting',
    name: 'PageClassrankSetting',
    component: () =>
      import(
        /* webpackChunkName: "classrank" */ '../pages/classrank/PageClassrankSetting'
      ),
    meta: {
      keepAlive: true,
      modular: 21,
      title: '设置',
      info: '班级评比——设置1'
    }
  }
]
